<script setup>
import { useI18n } from 'vue-i18n';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

defineProps({
  installmentCount: { type: Number, default: 0 },
  sentCount: { type: Number, default: 0 },
});

const emit = defineEmits(['complete']);
const { t } = useI18n();
</script>

<template>
  <section class="flex flex-wrap items-center justify-end gap-5">
    <p
      v-if="installmentCount > 1"
      data-testid="sent-count"
      class="text-sm text-lais-text-muted"
    >
      <strong class="text-lais-text">
        {{
          t('REAL_ESTATE_COMMISSION_PLAN.SUMMARY.SENT_RATIO', {
            sent: sentCount,
            total: installmentCount,
          })
        }}
      </strong>
      {{ t('REAL_ESTATE_COMMISSION_PLAN.SUMMARY.SENT') }}
    </p>
    <LaisPrimaryButton icon="i-lucide-check" @click="emit('complete')">
      {{ t('REAL_ESTATE_COMMISSION_PLAN.ACTIONS.COMPLETE') }}
    </LaisPrimaryButton>
  </section>
</template>
